import { Directive, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { DOWN_ARROW, ENTER, ESCAPE, TAB, UP_ARROW } from '@angular/cdk/keycodes';

@Directive({
    selector: '[fiInputKeyboardNavigation]',
    exportAs: 'fiInputKeyboardNavigation',
    standalone: false,
})
export class InputKeyboardNavigationDirective implements OnInit {
    @Input() keyboardIndex: number = -1;
    @Output('keyboardIndexChange') keyboardIndexChange: EventEmitter<number> = new EventEmitter<number>();
    @Output('keyboardIndexNext') keyboardIndexNext: EventEmitter<number> = new EventEmitter<number>();
    @Output('keyboardIndexPrev') keyboardIndexPrev: EventEmitter<number> = new EventEmitter<number>();
    @Input() keyboardIndexMin: number = 0;
    @Input() keyboardIndexMax: number = 0;
    @Input() keyboardIndexCircular: boolean = false;
    @Output('keyboardIndexSelect') keyboardIndexSelect: EventEmitter<number> = new EventEmitter<number>();
    @Output('keyboardIndexCancel') keyboardIndexCancel: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit() {
        this.renderer.listen(this.elementRef.nativeElement, 'keydown', ($event) => this.processKeydownEvent($event));
    }

    private processKeydownEvent($event) {
        switch ($event.keyCode) {
            case UP_ARROW:
                $event.preventDefault();
                if (this.keyboardIndex > this.keyboardIndexMin) {
                    this.setKeyboardIndex(this.keyboardIndex - 1);
                    this.keyboardIndexPrev.emit(this.keyboardIndex);
                } else if (this.keyboardIndexCircular === true) {
                    this.setKeyboardIndex(this.keyboardIndexMax);
                    this.keyboardIndexPrev.emit(this.keyboardIndex);
                }
                break;
            case DOWN_ARROW:
                if (this.keyboardIndex < this.keyboardIndexMax) {
                    this.setKeyboardIndex(this.keyboardIndex + 1);
                    this.keyboardIndexNext.emit(this.keyboardIndex);
                } else if (this.keyboardIndexCircular === true) {
                    this.setKeyboardIndex(this.keyboardIndexMin);
                    this.keyboardIndexNext.emit(this.keyboardIndex);
                }
                break;
            case ENTER:
                this.keyboardIndexSelect.emit(this.keyboardIndex);
                break;
            case TAB:
            case ESCAPE:
                this.keyboardIndexCancel.emit();
                break;
        }
    }

    setKeyboardIndex(keyboardIndex) {
        this.keyboardIndex = keyboardIndex;
        this.keyboardIndexChange.emit(keyboardIndex);
    }

    reset() {
        this.keyboardIndex = -1;
    }
}
